<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" align="center" :formdata="getBase" :value="formData"></compFormQuery>
			<compFormEdit v-else ref="relation" align="center" class="margin-layout" :formdata="getBase" v-model="formData"/>
		</compWrapper>
		<compWrapper :title="$t('global.log.name',{defaultValue:'操作历史'})" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper>
		<div class="text-right">
			<vButton v-if="!query" theme="primary" class="width-15per" @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</vButton>
            <vButton class="width-15per margin-left-10" @click="cancel">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
		</div>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>
<script>

import { HttpGetBaseCostOne, HttpSaveBaseCostOne, HttpGetLog } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';

export default {
	mixins:[mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			formData: {
				// remark:'',
			}
		}
	},
	created() {
		// console.log(this.$route.params.type)
		this.query = this.type === "query";
		this.getDetail()
	},
	computed: {
		getBase() {
			let showquery = this.type == 'edit' || this.type == 'query'
			return [
				{
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
					key: "account",
					tag:'vInput',
                    required:false,
					query:showquery,
				},
				{
					label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
					required:false,
					query:showquery,
					valueText:`${this.formData.carrierCode} (${this.formData.carrierServiceCode})`,
				},
				{
					label: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
					query:showquery,
					valueText:`${this.formData.zoneCode}`,
				},
				{
					label: this.$t('global.common.weight',{defaultValue:'重量'}),
					key: "weight",
					query:showquery,
					required:false,
					valueText:`${this.formData.weight} lbs`,
				},
				{
					label: this.$t('global.common.weight',{defaultValue:'费用'}),
					tag:'vInput',
					key: "cost",
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">USD</span>
					},
					show:this.type!='query'
				},
				{
					label: this.$t('global.common.weight',{defaultValue:'费用'}),
					valueText:`${this.formData.cost} USD`,
					show:this.type=='query'
				},
			];
		},
	},
	methods: {
		async getDetail() {
            if (this.type == 'add') return;
            this.loading = true;
            HttpGetBaseCostOne({
                id: this.id
            }).then(res => {
				this.formData = res.data
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
			});
			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:23,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{
	
				})
			}
		},
		async submit(){
			const valid = await this.$refs['relation'].validate();
			if (!valid) return;
			this.loading = true
			HttpSaveBaseCostOne({
				id:this.id,
				...this.formData,
				contextId:global.SYSID
			}).then(res=>{
				this.$VMessage.success(res.message);
				this.cancel()
			},err=>{
				this.$VMessage.error(err.message);
			}).finally(res=>{
				this.loading = false
			})	
		},
		cancel(){
			this.$router.push({ name: "fedexBasecost" })
		}	
	},
}
</script>
